import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation createVote($activityId: String!, $comment: String, $ratingQuality: Int!, $ratingSpeed: Int!){
  createVote(activityId: $activityId, ratingQuality: $ratingQuality, ratingSpeed: $ratingSpeed, comment: $comment)
}`;

function createVote(activityId, ratingQuality, ratingSpeed, comment) {
  return apollo.client.mutate({
    mutation,
    variables: {
      activityId,
      ratingQuality: parseInt(ratingQuality, 10) || 0,
      ratingSpeed: parseInt(ratingSpeed, 10) || 0,
      comment,
    },
  });
}

export default createVote;
